import { forwardRef } from 'react';
import { classNames } from 'tradera/utils/class-names';
import styles from './settings-row.module.scss';

type Props = {
    subLabel?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
};

export const SettingsRow = forwardRef<HTMLDivElement, Props>(
    ({ subLabel, children, className }, ref) => {
        return (
            <div
                className={classNames(styles.settingsRow, className)}
                ref={ref}>
                <div className="d-flex justify-content-between align-items-center">
                    {children}
                </div>
                {subLabel && (
                    <div
                        className={classNames(
                            'mr-7 text-gray-600 mt-1',
                            styles.subLabel,
                        )}>
                        {subLabel}
                    </div>
                )}
            </div>
        );
    },
);

SettingsRow.displayName = 'SettingsRow';
